import apiClient from "./apiClient";

const withoutEmpty = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value != null),
  );

// Overtime { id, date, startTime, endTime, requestedMinutes, approvedMinutes, countedMinutes,
//            countedHours, reason, status: "PENDING"|"APPROVED"|"REJECTED"|"CANCELLED",
//            reviewedAt, reviewRemarks, createdAt, canCancel?, levels: { current, total },
//            approvals: [{ level, action: "APPROVE"|"REJECT", name, at, remarks, approvedMinutes }] }
// Status stays PENDING until the last level approves. waitingFor: [{ id, name }] at the current
// level (any one can act), [] = branch manager / HR, null when not pending.
// The employee is taken from the access token.
export const overtimeService = {
  // { date, workedMinutes, beyondRegularMinutes, firstCheckIn, regularEndsAt (first check-in + 8 h),
  //   lastCheckOut, lockedReason, rule, requests: Overtime[] }
  getPreview: (date) =>
    apiClient.get("/overtime/preview", { params: withoutEmpty({ date }) }),

  // { date: "YYYY-MM-DD", startTime, endTime (ISO with +08:00), reason } -> Overtime
  create: (data) => apiClient.post("/overtime", data),

  // status, from, to -> Overtime[] (not paginated)
  getMine: (filters = {}) =>
    apiClient.get("/overtime/my", { params: withoutEmpty(filters) }),

  cancel: (id) => apiClient.post(`/overtime/${id}/cancel`),
};

export const approverService = {
  // { employeeId, approvers: [{ level, employeeId, employeeNumber, name }] (own chain),
  //   byType: [{ requestType: "DTR"|"OVERTIME"|"LEAVE"|"VALIDATION", label, source: "EMPLOYEE"|"RULE"|"DEFAULT",
  //              levels: [{ level, approvers: [{ id, employeeNumber, name, branchName }] }] }] }
  // Any one approver of a level can approve it. DEFAULT = branch manager / HR.
  getMine: () => apiClient.get("/approvers/me"),
};
